import ServiceProviderEdit from './ServiceProviderEdit';

export default ServiceProviderEdit; 


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServiceProviderEdit/index.js